import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { MerchSizes } from './constants';
import { buildMerchStoreConfig } from '../storeAliasHelper';
import { data_STAGING } from './STAGING';

export const UltraverseTshirtWhiteProduct = {
  title: "'Ultraverse' White T-shirt",
  description: '100% organic Supima cotton. Made carbon neutral.',
  imgSrc: 'web_v2/all-products/merch/new/verse-tee-white.png/w_1920',
  shopifyProductName: 'Ultraverse T-shirt',
  availableSizes: [
    MerchSizes.S,
    MerchSizes.M,
    MerchSizes.L,
    MerchSizes.XL,
    MerchSizes.XXL,
  ],
};

export const UltraverseTshirtWhiteShopifyMap: Record<
  ShopifyStore,
  {
    price: number;
    sizes: Record<MerchSizes, { variantId: string; checkoutUrl: string }>;
  }
> =
  process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
    ? buildMerchStoreConfig<MerchSizes>({
        [ShopifyStore.AE]: {
          price: 95,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/44691329450226',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691329450226:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/44691329515762',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691329515762:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/44691329581298',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691329581298:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/44691329646834',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691329646834:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/44691329712370',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691329712370:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.US]: {
          price: 25,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40200400633952',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200400633952:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40200400699488',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200400699488:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40200400765024',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200400765024:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40200400830560',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200400830560:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40200400896096',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200400896096:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.ROW]: {
          price: 25,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40718633467964',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718633467964:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40718633533500',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718633533500:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40718633599036',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718633599036:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40718633664572',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718633664572:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40718633730108',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718633730108:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.IN]: {
          price: 1599,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40737965244486',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737965244486:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40737965310022',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737965310022:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40737965375558',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737965375558:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40737965441094',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737965441094:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40737965506630',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737965506630:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.EU]: {
          price: 23,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/49202539430206',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202539430206:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/49202539495742',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202539495742:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/49202539561278',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202539561278:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/49202539626814',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202539626814:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/49202539692350',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202539692350:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.GB]: {
          price: 20,
        },
        [ShopifyStore.AU]: {
          price: 38,
        },
        [ShopifyStore.CA]: {
          price: 35,
        },
        [ShopifyStore.MX]: {
          price: 534,
        },
        [ShopifyStore.SA]: {
          price: 109,
        },
        [ShopifyStore.ZA]: {
          price: 499,
        },
        [ShopifyStore.JP]: {
          price: 3800,
        },
      })
    : data_STAGING;
